// i18n namespace "approach" (spec c.7 §6; copy from finance.md §2 with the bracketed
// items and the certification wording dropped). {{minutes}} comes from Approach.tsx.

export const en = {
  label: "How we work",
  title: "Three ways to work with us",
  models: {
    consulting: {
      title: "Senior consultants, by the day or month",
      text: "SAP FICO and EWM specialists who join your team or your integrator’s. Time and materials, invoiced monthly.",
    },
    assessment: {
      title: "Fixed-scope assessments",
      text: "A defined deliverable at a fixed price: S/4HANA readiness, EWM health check, finance close review. You know the cost before we start.",
    },
    placement: {
      title: "Direct-hire placement",
      text: "We find the SAP professional and you hire them. You pay a success fee only when the hire is made.",
    },
  },
  note: "Every engagement starts with a {{minutes}}-minute call and a written proposal.",
  cta: "Talk to an SAP expert",
};

export const es = {
  label: "Cómo trabajamos",
  title: "Tres formas de trabajar con nosotros",
  models: {
    consulting: {
      title: "Consultores senior, por día o por mes",
      text: "Especialistas SAP FICO y EWM que se integran a tu equipo o al de tu integrador. Tiempo y materiales, con facturación mensual.",
    },
    assessment: {
      title: "Diagnósticos de alcance fijo",
      text: "Un entregable definido a precio fijo: preparación para S/4HANA, revisión de EWM, revisión del cierre contable. Conoces el costo antes de empezar.",
    },
    placement: {
      title: "Reclutamiento directo",
      text: "Encontramos al profesional SAP y tú lo contratas. Pagas una cuota de éxito solo cuando se concreta la contratación.",
    },
  },
  note: "Todo proyecto inicia con una llamada de {{minutes}} minutos y una propuesta por escrito.",
  cta: "Habla con un experto SAP",
};

export const fr = {
  label: "Notre façon de travailler",
  title: "Trois façons de travailler avec nous",
  models: {
    consulting: {
      title: "Des consultants seniors, à la journée ou au mois",
      text: "Des spécialistes SAP FICO et EWM qui rejoignent votre équipe ou celle de votre intégrateur. En régie, facturé chaque mois.",
    },
    assessment: {
      title: "Diagnostics à périmètre fixe",
      text: "Un livrable défini à prix fixe : préparation à S/4HANA, bilan de santé EWM, revue de la clôture financière. Vous connaissez le coût avant de commencer.",
    },
    placement: {
      title: "Recrutement direct",
      text: "Nous trouvons le professionnel SAP et vous l’embauchez. Vous ne payez des honoraires de succès qu’une fois l’embauche conclue.",
    },
  },
  note: "Chaque mission commence par un appel de {{minutes}} minutes et une proposition écrite.",
  cta: "Parler à un expert SAP",
};

export const pt = {
  label: "Como trabalhamos",
  title: "Três formas de trabalhar conosco",
  models: {
    consulting: {
      title: "Consultores sêniores, por dia ou por mês",
      text: "Especialistas SAP FICO e EWM que se juntam à sua equipe ou à do seu integrador. Tempo e materiais, com faturamento mensal.",
    },
    assessment: {
      title: "Diagnósticos de escopo fechado",
      text: "Uma entrega definida a preço fixo: prontidão para S/4HANA, avaliação do EWM, revisão do fechamento contábil. Você sabe o custo antes de começarmos.",
    },
    placement: {
      title: "Recrutamento direto",
      text: "Encontramos o profissional SAP e você o contrata. Você paga uma taxa de sucesso somente quando a contratação acontece.",
    },
  },
  note: "Todo projeto começa com uma ligação de {{minutes}} minutos e uma proposta por escrito.",
  cta: "Fale com um especialista SAP",
};
